const isLoading = state => state.isLoading

const direction = state => state.direction

const user = state => state.user

const mainTitle = state => state.mainTitle

const client = state => state.client

export default {
  isLoading,
  direction,
  user,
  mainTitle,
  client
}



// WEBPACK FOOTER //
// ./src/store/getters.js